import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "left" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Prompts = _resolveComponent("Prompts")
  const _component_Icon = _resolveComponent("Icon")
  const _component_Tooltip = _resolveComponent("Tooltip")
  const _component_CommandsMenu = _resolveComponent("CommandsMenu")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Prompts, {
      class: "prompts",
      onSelectPrompt: _cache[0] || (_cache[0] = $event => (_ctx.$emit('prompt', $event)))
    }),
    ($props.uploadsEnabled)
      ? (_openBlock(), _createBlock(_component_Tooltip, {
          key: 0,
          text: "Attach file"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Icon, {
              class: "pointer",
              stroke: "var(--gray-light-700)",
              width: "1.6rem",
              height: "1.6rem",
              icon: "attachment-02",
              "stroke-width": "1",
              disabled: !$props.canUpload,
              hoverable: "",
              onClick: _cache[1] || (_cache[1] = _withModifiers($event => (_ctx.$emit('upload')), ["stop"]))
            }, null, 8 /* PROPS */, ["disabled"])
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_CommandsMenu, {
      onSkill: _cache[2] || (_cache[2] = $event => (_ctx.$emit('skill', $event))),
      onSource: _cache[3] || (_cache[3] = $event => (_ctx.$emit('source', $event)))
    })
  ]))
}